import type { ComponentPropsWithRef, ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface CardProps extends ComponentPropsWithRef<'div'> {
  inset?: boolean
  interactive?: boolean
}

export function Card({ className, inset, interactive, ...props }: CardProps) {
  return (
    <div
      className={cn(
        'rounded-card bg-surface shadow-card',
        inset ? 'p-0' : 'p-5',
        interactive && 'transition-all duration-150 ease-spring hover:-translate-y-px hover:shadow-(--shadow-card-hover)',
        className,
      )}
      {...props}
    />
  )
}

interface CardHeaderProps {
  title: ReactNode
  subtitle?: ReactNode
  action?: ReactNode
  className?: string
}

export function CardHeader({ title, subtitle, action, className }: CardHeaderProps) {
  return (
    <div className={cn('flex items-start justify-between gap-4', className)}>
      <div className="min-w-0">
        <h3 className="text-sm font-semibold text-ink">{title}</h3>
        {subtitle ? <p className="mt-0.5 text-sm text-ink-faint">{subtitle}</p> : null}
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  )
}
